import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import Products from './Products';
import Loader from './Loader';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const CollectionCarousel = ({ title, subtitle, viewAllLink, products, isLoading }) => {
    if (isLoading) return <Loader />;
    const validProducts = (products || []).filter(p => !isNaN(Number(p.price)) && p.price != null);
    if (validProducts.length === 0) return null;

    return (
        <section className="product-spotlight collection-carousel-section">
            <Container>
                <div className="spotlight-section-header" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                    <h2 className="spotlight-section-title">{title}</h2>
                    <p className="spotlight-section-subtitle">{subtitle}</p>
                    {viewAllLink && (
                        <Link to={viewAllLink} className="collection-carousel-view-all">
                            View All &rarr;
                        </Link>
                    )}
                </div>

                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={16}
                    slidesPerView={2}
                    centerInsufficientSlides
                    navigation
                    pagination={{ clickable: true }}
                    breakpoints={{
                        576: { slidesPerView: 2, spaceBetween: 16 },
                        768: { slidesPerView: 3, spaceBetween: 20 },
                        992: { slidesPerView: 4, spaceBetween: 20 },
                        1200: { slidesPerView: 5, spaceBetween: 20 },
                    }}
                    style={{ paddingBottom: '48px' }}
                >
                    {validProducts.map((product) => (
                        <SwiperSlide key={product._id}>
                            <Products product={product} showDiscount={product.isClearance} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Container>
        </section>
    );
};

export default CollectionCarousel;
